export enum CursorState {
  NONE = 'none',
  DEFAULT = 'default',
  GRAB = 'grab',
  GRABBING = 'grabbing',
  POINTER = 'pointer',
  CROSSHAIR = 'crosshair',
  MOVE = 'move',
}
